import Form from "./Form";

function AddRecipe(props) {
  return <Form setToggleFetch={props.setToggleFetch} />;
}

export default AddRecipe;
